import { render } from "./completeOrders.vue?vue&type=template&id=bab5d32e"
import script from "./completeOrders.vue?vue&type=script&lang=js"
export * from "./completeOrders.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__